import React from "react";
import clsx from "clsx";
import Card from "@material-ui/core/Card";
import { withStyles } from "@material-ui/core/styles";

const StyledCardBox = withStyles((theme) => ({
  root: {
    width: "100%",
    // display: "flex",
    // justifyContent: "space-between",
    // alignItems: "center",
    padding: 16,
    backgroundColor: "#fff",
    border: "2px solid #EBEAEC",
    borderRadius: theme.spacing(3),
  },
}))(({ classes, className, ...props }) => {
  return <Card className={clsx(classes.root, className)} {...props} />;
});

export default StyledCardBox;
